import type {
  ShowcaseDataSource,
  ShowcaseProductsParams,
} from '~/api/data-source/showcase';
import { showcaseDataSource } from '~/api/data-source/showcase';
import type { ShowcaseGroup, ShowcaseProducts } from '~/api/model';
import {
  parseModel,
  showcaseGroupSchema,
  showcaseProductsSchema,
} from '~/api/model';

export interface ShowcaseRepository {
  getShowcaseGroup(showcaseGroupCode: string): Promise<ShowcaseGroup>;
  getShowcaseProducts(
    params: ShowcaseProductsParams,
  ): Promise<ShowcaseProducts>;
}

export class ShowcaseRepositoryImpl implements ShowcaseRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly dataSource: ShowcaseDataSource = showcaseDataSource,
  ) {}

  async getShowcaseGroup(showcaseGroupCode: string) {
    const response = await this.dataSource.getShowcaseGroup(showcaseGroupCode);
    return parseModel(showcaseGroupSchema, response, 'ShowcaseGroup');
  }

  async getShowcaseProducts(params: ShowcaseProductsParams) {
    const response = await this.dataSource.getShowcaseProducts(params);
    return parseModel(showcaseProductsSchema, response, 'ShowcaseProducts');
  }
}

export const showcaseRepository = new ShowcaseRepositoryImpl();
